import { ref } from '@vue/composition-api'
import GeozonesList from './components/GeozonesList'
import GeozonesMap from './components/GeozonesMap'
import useRequest from '@/compositions/useRequest'

export default {
  name: 'index',
  components: {
    GeozonesList, GeozonesMap,
  },
  props: {
    type: {
      type: String,
      default: 'new',
    },
  },
  setup(_, context) {
    const { $store } = context.root
    const { makeRequest, loading } = useRequest({
      context,
      request: () => $store.dispatch('geozones/fetch', { per: -1, page: 1 }),
    })

    const instances = ref([])

    const update = () => {
      makeRequest()
    }

    const init = async () => {
      const res = await makeRequest()
      instances.value = res.instances
    }

    init()

    return {
      loading,
      update,
      instances,
    }
  },
}
